var chunkToChildrenMap = {
	"5893": [
		5482,
		7199,
		8872,
		2245
	],
	"7579": [
		5482,
		7199,
		8872,
		2245
	]
};
__webpack_require__.f.preload = (chunkId) => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.G);
};